import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { Collapse } from '@mui/material';
import { Form } from 'react-final-form';

import { emptyGenerationFormValues } from '../../../scout-new/components/generation-section/GenerationSection';
import HideButton from '../../../components/hide-button/HideButton';
import validate from '../../../utils/validate';
import GenerationForm from './generation-form/GenerationForm';
import { ID8_TABS } from '../../../constants';
import { generationYopValidation } from './validation';

import scss from './GenerationSection.module.scss';

function GenerationSection({
  isShowGenerationForm,
  onShowGenerationForm,
  onGenerateMessages,
  onReply,
  onResetSession,
  onFileUpload,
}) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { t } = useTranslation('id8');

  const abortAction = useRef(null);
  const generationForm = useSelector((state) => state.id8.generationForm);
  const id8Tab = useSelector((state) => state.id8.id8Tab);

  const initialGenerationFormValuesValues = {
    byPass: generationForm.byPass || emptyGenerationFormValues.byPass,
    focusOn: generationForm.focusOn || emptyGenerationFormValues.focusOn,
    url: generationForm.url || emptyGenerationFormValues.url,
    docs: null,
    fileText: generationForm.fileText || '',
  };

  const handleSubmitGenerationForm = (values) => {
    let resultAction;

    if (id8Tab === ID8_TABS.IDEAS) {
      resultAction = dispatch(onGenerateMessages({ id, values }));
    }

    abortAction.current = resultAction?.abort;
  };

  useEffect(() => {
    return () => {
      if (abortAction.current) {
        abortAction.current();
      }
    };
  }, []);

  return (
    <div className={scss.generationSection}>
      <HideButton
        isShow={isShowGenerationForm}
        onToggleVisibility={onShowGenerationForm}
        label={t('openGenerationForm')}
      />

      <Collapse in={isShowGenerationForm}>
        <div className={scss.generationWrapper}>
          <Form
            initialValues={initialGenerationFormValuesValues}
            onSubmit={handleSubmitGenerationForm}
            subscription={{ submitting: true, pristine: true }}
            keepDirtyOnReinitialize
            validate={(values) => validate(values, generationYopValidation())}
            render={({ handleSubmit }) => (
              <GenerationForm
                onSubmit={handleSubmit}
                onReply={onReply}
                onResetSession={onResetSession}
                onFileUpload={onFileUpload}
              />
            )}
          />
        </div>
      </Collapse>
    </div>
  );
}

export default GenerationSection;
